import React from "react";

export const Field = ({ label, children, full }) => (
  <div className={`field${full ? " full" : ""}`}>
    <label className="lbl">{label}</label>
    {children}
  </div>
);

export const BiText = ({ label, value, onChange, area }) => (
  <div className="bi" data-testid={`bi-${label.replace(/\W+/g, "-").toLowerCase()}`}>
    <div className="bi-h">
      {label} {value && !value.bn && value.en ? <span className="bn-miss">Bangla missing</span> : null}
    </div>
    <div className="field">
      <label className="lbl">English</label>
      {area ? <textarea rows={3} value={value?.en || ""} onChange={(e) => onChange({ ...(value || {}), en: e.target.value })} />
            : <input value={value?.en || ""} onChange={(e) => onChange({ ...(value || {}), en: e.target.value })} />}
    </div>
    <div className="field">
      <label className="lbl">বাংলা <button type="button" className="copy" style={{ border: "1px solid var(--rule-2)", color: "var(--muted)", borderRadius: 2, background: "transparent", cursor: "pointer" }} onClick={() => onChange({ ...(value || {}), bn: value?.en || "" })}>Copy English</button></label>
      {area ? <textarea rows={3} value={value?.bn || ""} onChange={(e) => onChange({ ...(value || {}), bn: e.target.value })} />
            : <input value={value?.bn || ""} onChange={(e) => onChange({ ...(value || {}), bn: e.target.value })} />}
    </div>
  </div>
);

export const BiLines = ({ label, value, onChange }) => (
  <div className="bi">
    <div className="bi-h">{label} (one per line)</div>
    <div className="field">
      <label className="lbl">English</label>
      <textarea rows={5} value={(value?.en || []).join("\n")}
        onChange={(e) => onChange({ ...(value || {}), en: e.target.value.split("\n").map((x) => x.trim()).filter(Boolean) })} />
    </div>
    <div className="field">
      <label className="lbl">বাংলা</label>
      <textarea rows={5} value={(value?.bn || []).join("\n")}
        onChange={(e) => onChange({ ...(value || {}), bn: e.target.value.split("\n").map((x) => x.trim()).filter(Boolean) })} />
    </div>
  </div>
);

export const Check = ({ label, checked, onChange, testid }) => (
  <label className="consent" style={{ gridColumn: "auto" }}>
    <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid} />
    <span>{label}</span>
  </label>
);

export const Msg = ({ msg }) =>
  msg ? <p className={`msg ${/fail|error|could not|incorrect/i.test(msg) ? "err" : "ok"}`} role="status" data-testid="admin-msg">{msg}</p> : null;
